import React from 'react';

// Using weather-icons font library (https://github.com/erikflowers/weather-icons)
// Mapping Yr.no weather symbols to weather-icons CSS classes
const weatherIconMap = {
  'clearsky_day': 'wi-day-sunny',
  'clearsky_night': 'wi-night-clear',
  'fair_day': 'wi-day-sunny-overcast',
  'fair_night': 'wi-night-alt-partly-cloudy',
  'partlycloudy_day': 'wi-day-cloudy',
  'partlycloudy_night': 'wi-night-alt-cloudy',
  'cloudy': 'wi-cloudy',
  'rain': 'wi-rain',
  'rainshowers': 'wi-showers',
  'rainshowers_day': 'wi-day-showers',
  'rainshowers_night': 'wi-night-alt-showers',
  'lightrain': 'wi-sprinkle',
  'heavyrain': 'wi-rain-wind',
  'sleet': 'wi-sleet',
  'snow': 'wi-snow',
  'snowshowers': 'wi-snow-wind',
  'fog': 'wi-fog',
  'thunder': 'wi-thunderstorm',
  'rainandthunder': 'wi-storm-showers',
  'sleetandthunder': 'wi-storm-showers',
  'snowandthunder': 'wi-snow-thunderstorm',
};

// Legacy SVG icons (kept for fallback, but not used)
export const WeatherIcons = {
  // Clear sky day - sun with rays
  clearsky_day: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="32" cy="32" r="10"/>
      <line x1="32" y1="12" x2="32" y2="8"/>
      <line x1="32" y1="56" x2="32" y2="52"/>
      <line x1="12" y1="32" x2="8" y2="32"/>
      <line x1="56" y1="32" x2="52" y2="32"/>
      <line x1="18" y1="18" x2="15" y2="15"/>
      <line x1="49" y1="49" x2="46" y2="46"/>
      <line x1="18" y1="46" x2="15" y2="49"/>
      <line x1="49" y1="15" x2="46" y2="18"/>
    </svg>
  ),
  
  // Clear sky night - crescent moon
  clearsky_night: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M40 15c-7 0-13 5-15 12-1 3 0 7 2 10 3 3 7 5 11 5 7 0 13-5 15-12 1-3 0-7-2-10-3-3-7-5-11-5zM39 18c5 1 9 5 10 10-6-2-11-6-12-12 1 1 1 2 2 2z"/>
    </svg>
  ),
  
  // Partly cloudy day - sun behind cloud
  partlycloudy_day: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="24" cy="22" r="7"/>
      <line x1="24" y1="10" x2="24" y2="6"/>
      <line x1="11" y1="15" x2="8" y2="12"/>
      <line x1="6" y1="22" x2="10" y2="22"/>
      <line x1="37" y1="15" x2="40" y2="12"/>
      <path d="M36 28c0-2 2-4 4-4s4 2 4 4M52 36H28c-3 0-5-2-5-5s2-5 5-5c0-4 3-7 7-7s7 3 7 7c3 0 5 2 5 5s-2 5-5 5"/>
    </svg>
  ),
  
  // Partly cloudy night - moon behind cloud
  partlycloudy_night: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 14c4 0 7 2 9 5M52 36H28c-3 0-5-2-5-5s2-5 5-5c0-4 3-7 7-7s7 3 7 7c3 0 5 2 5 5s-2 5-5 5"/>
    </svg>
  ),
  
  // Cloudy - cloud
  cloudy: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M52 40H20c-4 0-7-3-7-7s3-7 7-7c0-5 4-9 9-9s9 4 9 9c4 0 7 3 7 7s-3 7-7 7"/>
      <path d="M44 36H16c-3 0-5-2-5-5s2-5 5-5c0-4 3-7 7-7s7 3 7 7c3 0 5 2 5 5s-2 5-5 5"/>
    </svg>
  ),
  
  // Rain - cloud with rain drops
  rain: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M48 32H24c-4 0-7-3-7-7s3-7 7-7c0-4 3-7 7-7s7 3 7 7c4 0 7 3 7 7s-3 7-7 7"/>
      <line x1="24" y1="38" x2="22" y2="46"/>
      <line x1="30" y1="40" x2="28" y2="48"/>
      <line x1="36" y1="38" x2="34" y2="46"/>
      <line x1="42" y1="40" x2="40" y2="48"/>
    </svg>
  ),
  
  // Rain showers - sun, cloud and rain
  rainshowers: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="22" cy="18" r="6"/>
      <line x1="22" y1="8" x2="22" y2="5"/>
      <line x1="11" y1="13" x2="8" y2="10"/>
      <line x1="33" y1="13" x2="36" y2="10"/>
      <path d="M48 32H28c-3 0-5-2-5-5s2-5 5-5c0-3 2-6 5-6s6 3 6 6c3 0 5 2 5 5s-2 5-5 5"/>
      <line x1="30" y1="38" x2="28" y2="44"/>
      <line x1="36" y1="40" x2="34" y2="46"/>
      <line x1="42" y1="38" x2="40" y2="44"/>
    </svg>
  ),
  
  // Heavy rain - cloud with more rain
  heavyrain: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M48 32H24c-4 0-7-3-7-7s3-7 7-7c0-4 3-7 7-7s7 3 7 7c4 0 7 3 7 7s-3 7-7 7"/>
      <line x1="22" y1="38" x2="20" y2="50"/>
      <line x1="28" y1="40" x2="26" y2="52"/>
      <line x1="34" y1="38" x2="32" y2="50"/>
      <line x1="40" y1="40" x2="38" y2="52"/>
      <line x1="46" y1="38" x2="44" y2="50"/>
    </svg>
  ),
  
  // Snow - cloud with snowflakes
  snow: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M48 32H24c-4 0-7-3-7-7s3-7 7-7c0-4 3-7 7-7s7 3 7 7c4 0 7 3 7 7s-3 7-7 7"/>
      <line x1="24" y1="40" x2="24" y2="46"/>
      <line x1="21" y1="43" x2="27" y2="43"/>
      <line x1="22" y1="41" x2="26" y2="45"/>
      <line x1="26" y1="41" x2="22" y2="45"/>
      <line x1="36" y1="42" x2="36" y2="48"/>
      <line x1="33" y1="45" x2="39" y2="45"/>
      <line x1="34" y1="43" x2="38" y2="47"/>
      <line x1="38" y1="43" x2="34" y2="47"/>
    </svg>
  ),
  
  // Sleet - cloud with rain and snow mix
  sleet: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M48 32H24c-4 0-7-3-7-7s3-7 7-7c0-4 3-7 7-7s7 3 7 7c4 0 7 3 7 7s-3 7-7 7"/>
      <line x1="26" y1="38" x2="24" y2="44"/>
      <line x1="38" y1="38" x2="36" y2="44"/>
      <line x1="32" y1="42" x2="32" y2="48"/>
      <line x1="29" y1="45" x2="35" y2="45"/>
    </svg>
  ),
  
  // Thunder - cloud with lightning
  thunder: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M48 28H24c-4 0-7-3-7-7s3-7 7-7c0-4 3-7 7-7s7 3 7 7c4 0 7 3 7 7s-3 7-7 7"/>
      <path d="M34 32L30 42h4l-2 10l8-14h-4l4-6z"/>
    </svg>
  ),
  
  // Fog - horizontal lines
  fog: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="16" y1="22" x2="48" y2="22"/>
      <line x1="12" y1="28" x2="52" y2="28"/>
      <line x1="16" y1="34" x2="48" y2="34"/>
      <line x1="20" y1="40" x2="44" y2="40"/>
      <line x1="16" y1="46" x2="48" y2="46"/>
    </svg>
  ),
  
  // Fair day - sun with small cloud
  fair_day: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="24" cy="22" r="7"/>
      <line x1="24" y1="10" x2="24" y2="6"/>
      <line x1="11" y1="15" x2="8" y2="12"/>
      <line x1="6" y1="22" x2="10" y2="22"/>
      <line x1="37" y1="15" x2="40" y2="12"/>
      <path d="M48 38H32c-2 0-4-2-4-4s2-4 4-4c0-3 2-5 5-5s5 2 5 5c2 0 4 2 4 4s-2 4-4 4"/>
    </svg>
  ),
  
  // Fair night - moon with small cloud
  fair_night: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M28 14c4 1 7 4 8 8-5-1-9-4-10-9 1 0 1 1 2 1z"/>
      <path d="M48 38H32c-2 0-4-2-4-4s2-4 4-4c0-3 2-5 5-5s5 2 5 5c2 0 4 2 4 4s-2 4-4 4"/>
    </svg>
  )
};

export const getWeatherIcon = (symbol, size = '3.5rem') => {
  const normalizedSymbol = symbol ? symbol.toLowerCase().replace(/_/g, '') : '';
  
  // Find matching icon class
  let iconClass = 'wi-cloudy'; // default
  
  // Try exact match first
  if (weatherIconMap[symbol]) {
    iconClass = weatherIconMap[symbol];
  } else {
    // Try partial matches
    for (const [key, value] of Object.entries(weatherIconMap)) {
      if (normalizedSymbol.includes(key.replace(/_/g, ''))) {
        iconClass = value;
        break;
      }
    }
  }
  
  return (
    <i 
      className={`wi ${iconClass}`}
      style={{ 
        fontSize: size,
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    />
  );
};
